import { Grid } from '@mui/material';
import './customize-main.styles.scss';
import { Fragment, useContext, useEffect, useState } from 'react';
import Button from '../../../../components/button/button.component';
import { Link, useNavigate } from 'react-router-dom';
import Checkbox from '../../../../components/checkbox/checkbox.component';
import { CancelContext } from '../../../../contexts/cancellation.context';
import { updateBoxSeq } from '../../../../utils/recurly.functions';
import { addError, freshDeskReport, onlyUnique, removeErrorConfirm } from '../../../../utils/generaFunctions';
import useWindowDimensions from '../../../../hooks/useWindowDimensions';

const CustomizeMain = () => {
    const {height, width} = useWindowDimensions();
    const {userInfo, setLoading} = useContext(CancelContext);
    const navigate = useNavigate();
    const [options] = useState(["Ultimate Bridal Swag", "Wedding Day Essentials", "Keep Calm and Plan On", "It's Party Time!", "Blushing Bride", "Maximum Romance" , "Honeymooners", "Bride Vibes", "It's Official"]);
    const [optNum] = useState([2,3,4,5,6,7,8,9,15]);
    const [choice, setChoice] = useState([]);
    const [isUnderMd, setIsUnderMd] = useState(false);
    useEffect(()=>{
        if(choice.length!==0){
            removeErrorConfirm();
        }
    },[choice.length]);
    //screen size
    useEffect(()=>{
        if(width <= 900){
            setIsUnderMd(true);
        } else {
            setIsUnderMd(false);
        }
    },[height, width]);
    useEffect(()=>{
        let modal = document.getElementById("custom-popup");
        let modalContent = document.getElementById("modal-content");
        if(isUnderMd){
        modalContent.src = "https://misstomrsbox.com/wp-content/themes/misstomrs/imgs/whats_inside_mobile.jpg";
        modalContent.style.maxWidth = "320px";
        } else {
        modalContent.src = "https://misstomrsbox.com/wp-content/themes/misstomrs/imgs/whats_inside_desktop.jpg";
        modalContent.style.maxWidth = "700px";
        }
        window.document.getElementById("popup-inside").onclick= () =>{
        modal.style.display = "flex"; 
        };
        modal.onclick = function(e) {
        modal.style.display = "none"; 
        }
      },[isUnderMd])
    return (
        <Grid container className='main-container'>
            <Grid container item className='flex-vertical' xs={12}>
                <div>
                    <Grid item className='title' xs={12}>
                        <h1>Customize themes</h1>
                    </Grid>
                    <Grid item className='desc' xs={12}>
                        Select which themes you want to receive.<br/>
                        <Link id="popup-inside">Click here</Link> to read more about each theme.
                    </Grid>
                </div>
                <Grid item id='theme-container'>
                {options.map ? options.map((option, index) => {
                    console.log(option);
                    if(index===8){
                        return(
                            <Fragment>
                                <Grid key={index} item 
                                    sx={{ display:userInfo.box_seq && userInfo.box_seq.split("-").includes(String(optNum[index]))?"flex":"none"}} 
                                >
                                    <div style={{textAlign:"left"}}>&#128146; Your big day</div>
                                </Grid>
                                <Grid key={index} item 
                                    sx={{ display:userInfo.box_seq && userInfo.box_seq.split("-").includes(String(optNum[index]))?"flex":"none"}} 
                                    onClick={()=>{
                                        if(choice.includes(optNum[index])){
                                            setChoice(onlyUnique(choice.filter(x => x!==optNum[index])));
                                        }else {
                                            setChoice(onlyUnique([...choice, optNum[index]]))
                                        }
                                    }}>
                                    <Checkbox key={"checkbox"+index} checked={choice.includes(optNum[index])} small="yes"/>
                                    <div style={{marginLeft:"10px", textAlign:"left"}}>{option === "loading"?<div className='box-placeholder text'></div>:option }</div>
                                </Grid>
                            </Fragment>
                        )
                    }else {
                        return(
                            <Grid key={index} item 
                                sx={{ display:userInfo.box_seq && userInfo.box_seq.split("-").includes(String(optNum[index]))?"flex":"none"}} 
                                onClick={()=>{
                                    if(choice.includes(optNum[index])){
                                        setChoice(onlyUnique(choice.filter(x => x!==optNum[index])));
                                    }else {
                                        setChoice(onlyUnique([...choice, optNum[index]]))
                                    }
                                }}>
                                <Checkbox key={"checkbox"+index} checked={choice.includes(optNum[index])} small="yes"/>
                                <div style={{marginLeft:"10px", textAlign:"left"}}>{option === "loading"?<div className='box-placeholder text'></div>:option }</div>
                            </Grid>
                        )
                    }
                }): null}
                </Grid>
                <Grid item id='button-container'>
                    <Link 
                        className={`button-link`} 
                        onClick={()=>{
                            setLoading(true);
                            if(choice.length === 0){
                                addError(document.getElementById('theme-container'), 'Select one of the options above first and then click continue');
                            } else{
                                const notChosen = optNum.filter(x => !choice.includes(x));
                                const newBox = userInfo.box_seq?userInfo.box_seq.split("-").filter(x => !notChosen.includes(Number(x))).join("-"):"";
                                updateBoxSeq(userInfo.email, newBox).then((response)=>{
                                    if(response.success){
                                        freshDeskReport(userInfo.email, userInfo.name, "Box Seq Changed: " + newBox, "Sys2.0: Prevented", "Sys2.0: Prevented", "Sys2.0: Hand-pick themes").then(
                                            (response2)=> {
                                                navigate("confirmed"+window.location.search);
                                            })
                                    }else {
                                        navigate("confirmed"+window.location.search);
                                    }
                                }).catch(()=>{
                                    navigate("confirmed"+window.location.search);
                                });
                                }
                        }}
                    ><Button text="confirm"></Button></Link>
                    <Link className={`button-link`} to={"../keep"+window.location.search}><Button className="btn-reverse" text={"Keep my subscription as-is"}/></Link>
                </Grid>
                <Link className='go-back' to={'../'+window.location.search}>&lt;&lt; BACK TO PREVIOUS PAGE</Link>
            </Grid>
        </Grid>
    )
}

export default CustomizeMain;